import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=7b85335f&"
import script from "./AppComponent.vue?vue&type=script&lang=js&"
export * from "./AppComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports